<template>
<div>
  <nx-bform class="login-form" @submit="login">
    <h3 :style="isDayTime() ? '' : 'color: white'">{{ $t("title") }}</h3>

    <nx-bform-server-errors />

    <div class="login-box">
      <LoginEmailFormGroup v-model="identity.email" required />
      <LoginUUIDFormGroup v-model="identity.uuid" label="Access Code" required />
      <LoginOTPFormGroup
        v-model="identity.otp"
        required
        label="OTP(One Time Password)"
        @requestOTP="requestOTP"
      />
      <div class="d-flex">
        <b-button class="login-button" type="submit">{{
          $t("login")
        }}</b-button>
      </div>

      <div class="login-form__query"></div>
      <div class="shield">
        <img src="@/assets/login/shield.png" alt="shield" />
      </div>
    </div>
    <b-modal
      class="modelStyle"
      size="lg"
      id="otp-one-time-password"
      centered
      hide-footer
    >
      <div class="d-flex">
        <nx-bform @submit="onSubmit">
          <CaptchaFormGroup
            label-cols="2"
            label-align="right"
            v-model="form.captcha"
            @change-token="form.captchaToken = $event.token"
            required
          />

          <b-form-group label-cols="2">
            <b-button type="submit" class="confirm_btn">{{
              $t("confirm")
            }}</b-button>
          </b-form-group>
        </nx-bform>
      </div>
    </b-modal>
  </nx-bform>
  <div>
    <form method="post" id="eDrivePostDataForm"  :action="eDrivePostURL" >
      <input type="hidden" id="uuid" name="uuid" :value="identity.uuid" />
    </form>
  </div>
</div>
</template>

<script>
import LoginEmailFormGroup from "@/forms/login/LoginEmailFormGroup";
import LoginUUIDFormGroup from "@/forms/login/eDrive/LoginUUIDFormGroup";
import LoginOTPFormGroup from "@/forms/login/eDrive/LoginOTPFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import { EDriveApi } from "@/api";
export default {
  components: {
    LoginOTPFormGroup,
    LoginEmailFormGroup,
    LoginUUIDFormGroup,
    CaptchaFormGroup,
  },
  name: "loginEDriveForm",
  data() {
    return {
      identity: {
        email: "",
        uuid: "",
        otp: "",
      },
      form: {
        captcha: "",
        captchaToken: "",
      },
      eDrivePostURL:""
    };
  },
  async created() {
    var lang = this.$route.query.lang;
    if (lang) {
      this.$root.$i18n.locale = lang;
    }
  },
  methods: {
    async onSubmit() {

      EDriveApi.sendOTP(
          this.identity,
          this.form.captchaToken
      ).then((res) => {
      
        if (!res.data) {
          this.$dangerToast(this.$t("messages.errorTitle"), this.$t("messages.errorMsg"))
        }else
        {
          this.$successToast(this.$t("messages.successTitle"), this.$t("messages.successMsg"))
        }
          
      }).catch((ex) => {
        this.$dangerToast(this.$t("messages.errorTitle"), this.$t("messages.errorMsg"))
      })
      this.$bvModal.hide("otp-one-time-password");
      this.form.captcha = "";
    },
    async login() {
      try {
        const {status} = await EDriveApi.eDriveLogin(this.identity)
        if(status === 200){
        
          //this.eDrivePostURL= process.env.VUE_APP_EDRIVE_URL+"/#/PostEDriveData";
          //document.getElementById("eDrivePostDataForm").submit();
          //window.open(`http://localhost:8080/#/e-drive-download?acesscode=${this.identity.uuid}`)
          document.cookie = "AccessCode="+this.identity.uuid+"; path=/";
          document.cookie = "OTP="+this.identity.otp+"; path=/";
          window.location.href =  process.env.VUE_APP_EDRIVE_URL + `#/e-drive-download`;
          //window.location.href =  process.env.VUE_APP_EDRIVE_URL + `#/e-drive-download?accesscode=${this.identity.uuid}`;
        }
      }catch (e){
        console.log(e.response)
        this.$dangerToast(e.response.data, this.$t("messages."+e.response.data))
      }

      // CPSRequestRegistrationApi.eDriveLogin(this.identity).then(({res,status}) => {
      //   console.log(res);
      //   if(status === 200){
      //     window.open(`http://localhost:8080/#/e-drive-download?acesscode=${this.identity.uuid}`)
      //   }
      // }).catch(()=>{
      //   this.$dangerToast('ERR_ESS_REG_7019', this.$t("messages.ERR_ESS_REG_7019"))
      // });
    },
    requestOTP() {
      this.openModal();
    },
    openModal() {
      this.$bvModal.show("otp-one-time-password");
    },
    closeModal() {
      this.$bvModal.hide("otp-one-time-password");
    },
    goToRegister() {
      this.$router.push({
        name: "ERegistrationProfessionalActivate",
      });
    },
    isDayTime() {
      const nowTime = moment().hour();
      if (nowTime >= 6 && nowTime < 18) return true;
      else return false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .col-form-label{
  color: #262626;
}
.confirm_btn {
  background-color: #cc4400;
  border: none;
}
.confirm_btn :hover,
.confirm_btn :focus {
  background-color: #005d99;
}
.registration-professional-activate {
  padding: 50px 0;
  justify-content: space-around;
  .register {
    width: 200px;
    height: 150px;
    color: #fff;
    line-height: 150px;
    /*padding-top: 50px;*/
    text-align: center;
    display: table-cell;
    /*font-weight: 800;*/
    background-color: #005e97;
    border-radius: 0.25rem;
    cursor: pointer;
  }
  .login .btn_text {
    /*width: 200px !important;*/
    /*font-weight: 800 !important;*/
    /*white-space: normal !important;*/
  }
  .login .btn_text span {
    white-space: normal !important;
  }
}
.info-btn {
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #005d99;
  border: 1px;
  font-weight: 400 !important;
}
.modelStyle .bg-secondary {
  background-color: #005d99 !important;
}
</style>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>

<i18n>
{
  "en": {
    "messages": {
      "successTitle": "Success",
      "successMsg": "OTP sent successfully",
      "errorTitle": "Error",
      "errorMsg": "AccessCode or Email ERROR",
      "ERR_ESS_REG_7019":"Login failed, please check and try again",
      "ERR_ESS_REG_7020":"This Request is Cancel"
    }
  },
  "zh_hk": {
    "messages": {
      "successTitle": "成功",
      "successMsg": "成功發送 OTP（一次性密碼）",
      "errorTitle": "發生錯誤",
      "errorMsg": "AccessCode或Email錯誤",
      "ERR_ESS_REG_7019":"登錄失敗，請檢查後重試",
      "ERR_ESS_REG_7020":"该分享已取消"
    }
  },
  "zh_cn": {
    "messages": {
      "successTitle": "成功",
      "successMsg": "成功发送 OTP（一次性密码）",
      "errorTitle": "发生错误",
      "errorMsg": "AccessCode或Email错误",
      "ERR_ESS_REG_7019":"登录失败，请检查后重试",
      "ERR_ESS_REG_7020":"该分享已取消"
    }
  }
}
</i18n>
